import React from 'react';
import { Box } from '@mui/material';

/**
 * Punto liso de etapa: el mismo del panel de Leads / Consultas
 * (`LeadInterestStageMenu`). Único estilo de etapa en todo el Front:
 * leads, cards de Registros, detalle de lista, listado de UF y fichas.
 */
export const STAGE_DOT_SIZE = 7;
export const STAGE_DOT_FALLBACK = 'rgba(255,255,255,0.35)';

export const stageDotSx = (color) => ({
  width: STAGE_DOT_SIZE,
  height: STAGE_DOT_SIZE,
  borderRadius: '50%',
  flexShrink: 0,
  bgcolor: color || STAGE_DOT_FALLBACK,
});

export default function StageDot({ color, sx, ...rest }) {
  return <Box component="span" {...rest} sx={{ ...stageDotSx(color), display: 'inline-block', ...sx }} />;
}
